import * as dTokens from "./design-tokens"

/* Typography
    Values taken from https://www.figma.com/file/EfELYUubYAei7PmUDW1AIk/ADS-Provider---Working---1.1?node-id=207%3A977
   ========================================================================== */
export const import_opensans =
   'https =//fonts.googleapis.com/css2?family =Open+Sans =ital,wght@0,300";0,400";0,600";0,700";0,800";1,300";1,400";1,600";1,700";1,800&display =swap';
 export const font_family =
   '"Open Sans", "Helvetica Neue", "Helvetica", Helvetica, Arial, sans_serif"';
 
// Font weights
export const font_weight_thin = 100;
export const font_weight_light = 300;
export const font_weight_normal = 400;
export const font_weight_medium = 600;
export const font_weight_bold = 700;
export const font_weight_extra = 800;
export const font_weight_black = 900;

// Font sizes
export const font_size_page_header_h1 = "36px";
export const font_size_header_h2 = "24px";
export const font_size_subheader_h3 = "20px";
export const font_size_title_h4 = "16px";
export const font_size_subtitle_h5 = "14px";

export const font_weight_page_header_h1 = font_weight_light;
export const font_weight_header_h2 = font_weight_medium;
export const font_weight_subheader_h3 = font_weight_normal;
export const font_weight_title_h4 = font_weight_medium;
export const font_weight_subtitle_h5 = font_weight_medium;

export const font_size_body_text = "14px";
export const font_size_text_link = "14px";
export const font_size_data_values = "13px";
export const font_size_caption = "12px";
export const font_size_graph_elements = "11px";
export const font_size_form_labels = "11px";
export const font_size_table_headers_12 = "12px";
export const font_size_table_headers_14 = "14px";
export const font_size_table_content_12 = "12px";
export const font_size_table_content_14 = "14px";
export const font_size_small_button_label = "10px";

export const font_weight_body_text = font_weight_normal;
export const font_weight_text_link = font_weight_normal;
export const font_weight_data_values = font_weight_normal;
export const font_weight_caption = font_weight_normal;
export const font_weight_graph_elements = font_weight_medium;
export const font_weight_form_labels = font_weight_medium;
export const font_weight_table_headers_12 = font_weight_medium;
export const font_weight_table_headers_14 = font_weight_medium;
export const font_weight_table_content_12 = font_weight_normal;
export const font_weight_table_content_14 = font_weight_normal;
export const font_weight_small_button_label = font_weight_normal;

// Font colours
export const main_font_colour = dTokens.res_grey_800;
export const light_font_colour = dTokens.res_grey_700;
export const link_font_colour = dTokens.res_brand_color_005;

export const font_colour_page_header_h1 = main_font_colour;
export const font_colour_header_h2 = main_font_colour;
export const font_colour_subheader_h3 = main_font_colour;
export const font_colour_title_h4 = main_font_colour;
export const font_colour_subtitle_h5 = main_font_colour;

export const font_colour_body_text = main_font_colour;
export const font_colour_text_link = link_font_colour;
export const font_colour_data_values = main_font_colour;
export const font_colour_caption = light_font_colour;
export const font_colour_graph_elements = light_font_colour;
export const font_colour_form_labels = main_font_colour;
export const font_colour_table_headers_12 = main_font_colour;
export const font_colour_table_headers_14 = main_font_colour;
export const font_colour_table_content_12 = main_font_colour;
export const font_colour_table_content_14 = main_font_colour;
export const font_colour_small_button_label = main_font_colour;
